module.exports = __webpack_public_path__ + "img/newsImg6-8.ef126403.png";